/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;

var debugMode = window.ENV == 'local';

/**
 * DOM ready
 */
$(function() {

});


/**
 * Load
 */
$(window).on("load", function() {

    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function() {

        lenisInit();

        barbaInit();

        initMenu();

        //initSeguiMouse();

        initHeader();

        initVideoSources();

        initPannelli();

        initLogoSwiss();

        initListHover();

        initStoriaSlider();

        lazySizes.init();

        pageEnter();

        //setTimeout(function() {
            $('body').removeClass('loading');
        //}, 200);

        //gallery tipo marquee
        //initGalleryFreeMode();


    });


    /**
     * Configurazione globale componenti uikit
     */
    (function() {
        // container false per modal, evita duplicazione elemento in seguito a caricamenti asincroni (barba.js)
        UIkit.mixin({
            data: {
                container: false,
            }
        }, 'modal');
    })();


    /**
     * Update necessari dopo caricamenti livewire
    */
    Livewire.hook('message.processed', function () {
      
        // scroll a eventuale messaggio di errore form
        scrollToFormError();

    });


    // scroll a eventuale messaggio di errore form, al caricamento!
    scrollToFormError();
        
    
    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");


});


/**
 * Scroll al primo messaggio di errore di un form
 */
function scrollToFormError()
{
    // se ho dei messaggi di validazione di un form, scrollo al primo messaggio
    if (!$('form .field__error').length) {
        return;
    }

}


/**
 * Funzione di uscita pagina
 */
function pageExit(callback){
    if(debugMode){console.log("-----page EXIT")}
    // porto in primo piano prima di iniziare animazione
    $("#page_loader").css({
        zIndex: 49 // sotto all'header!
    });

    // header in positivo durante la transizione
    $('body').addClass('header-positivo');

    //animazione in uscita dalla pagina (il loader entra con fade in)
    $( "#page_loader" ).animate({opacity: 1}, 400, function() {
        // Animation complete

        lenis.start();

        if (callback && typeof(callback) == 'function') {
            callback();
        }
    });
}


/**
 * Funzione di entrata pagina
 */
function pageEnter(callback){
    //animazione in entrata della pagina (uscita del loader)
    $( "#page_loader" ).animate({opacity: "0"}, 1000, function() {

        // Animation complete
        updateSeguiMouse();

        //anchor link
        document.querySelectorAll('a[href^="#"].anchor').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                lenis.scrollTo(this.getAttribute('href'))
            });
        })

        // porto sotto per poter interagire con pagina
        $("#page_loader").css({
            zIndex: -1,
            opacity: 0
        });
        if (callback && typeof(callback) == 'function') {
            callback();
        }
    })
    

}


function lenisInit(){
    
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
        direction: "vertical",
        gestureDirection: "vertical",
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 2,
    });

    
    lenis.on('scroll', (e) => {
        var dir = e.direction;
        var scroll = e.scroll;
        if(dir==1) { //scroll down
            $('body').removeClass("menuOpen");
            if(scroll > 100){
                $('body').addClass("scrolling");
                $('body').addClass("header-hidden");
            }
        } else{
            //scroll up
            $('body').removeClass("header-hidden");
            if(scroll < 100){
                $('body').removeClass("scrolling");
            }
        }
    })
    

    // integrazione con gsap.ticker (sincronizza lenis e scrolltrigger sullo stesso frame)
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    // aggiorna ScrollTrigger ad ogni scroll lenis (una volta sola qui, non in initPannelli)
    lenis.on('scroll', ScrollTrigger.update);

    window.lenis = lenis;
}


/**
 * Gestione caricamento asincrono
 */
function barbaInit()
{
   
    // controllo disponibilità barba
    if(typeof(barba) === "undefined") {
        return console.log("barba non disponibile");
    }

    barba.init({
        debug: window.ENV === 'local',
        logLevel: window.ENV === 'local' ? 'debug' : 'error',
        cacheIgnore: true, // da usare in combinazione con window.livewire.rescan() dopo la transizione (v. sotto)
        timeout: 10000,
        transitions: [{
            name: 'default-transition',
            beforeLeave(data) {
               
                console.log("beforeLeave");

                // attendi finchè loader entra prima di lasciare la pagina
                const done = this.async();
                
                // qui posso fare altre cose.....
                return pageExit(function() {
                    return done();
                });

            },
            leave(data) {
                //console.log("leave");
                lenis.scrollTo(0, {immediate:true});
                ScrollTrigger.getAll().forEach(function(st) { st.kill(); });
            },
            afterLeave(data) {
                //console.log("afterLeave");
            },
            beforeEnter(data) {

                //console.log("beforeEnter");
            },
            enter(data) {
                //console.log("enter");
            },
            afterEnter(data) {

                // tracciamento analytics
                if(typeof(gtag) == 'function' && typeof(GA_MEASUREMENT_ID) != 'undefined') {
                    gtag('config', GA_MEASUREMENT_ID, {'page_path': window.location.pathname});
                }

                updateDom(data, function() {
                    updateMenuActive();

                    initHeader();
                    initVideoSources(data.next.container);
                    initListHover();
                    initStoriaSlider();
                    requestAnimationFrame(function() {
                        initPannelli();
                        initLogoSwiss();
                        gsap.delayedCall(0.1, function() {
                            ScrollTrigger.refresh();
                        });
                    });
                    pageEnter();

                    // rebind degli eventi livewire sui nuovi contenuti caricati
                    if(window.livewire) {
                        window.livewire.rescan();
                    }

                    // imposta subito il colore header corretto per la nuova pagina
                    // senza aspettare lo scroll (es. privacy→home senza scrollare)
                    const negativo = data.next.container.getAttribute('data-negativo');
                    if (negativo !== null) {
                        document.body.classList.toggle('header-positivo', negativo === 'false');
                    }
                });

            }
        }],
        views: [
            {
                namespace : 'news',
                afterEnter(data) {
                    console.log("afterenter solo per namespace news");
                }
            }
        ],
        requestError: (trigger, action, url, response) => {

            // forzo a seguire le url 404 per visione del messaggio
            if(action == 'click' && response.status == 404) {
                window.location.href = url;
                return false;
            }

            // in caso di timeout o altro errore al click, naviga normalmente
            if(action == 'click') {
                window.location.href = url;
                return false;
            }

            console.log(trigger, action, url, response);

        },
        preventRunning : true
    });
}


//icona che segue il mouse
var cursor;
function initSeguiMouse() {
    /*
    if ($('html').hasClass('no-touch')) {
        //rollover con icona che segue il cursore 
        cursor = $(".myCursor");
        var $mouseX = 0,
            $mouseY = 0;
        var $xp = 0,
            $yp = 0;

        $(document).on("mousemove", function (e) {
            $mouseX = e.clientX + 25;
            $mouseY = e.clientY + 25;
        });

        var $loop = setInterval(function () {
            $xp += (($mouseX - $xp) / 5);
            $yp += (($mouseY - $yp) / 5);
            cursor.css({ left: $xp + 'px', top: $yp + 'px' });
            
        }, 30);

        updateSeguiMouse();

    }
    */
}
function updateSeguiMouse() {

    /*
    cursor.removeClass("drag cursor-discover cursor-gallery cursor-scroll");


    if ($('html').hasClass('no-touch')) {
        
       
        //drag
        $(".hover-drag").on("mouseenter", function () {
            cursor.addClass("drag");
        });
        $(".hover-drag").on("mouseleave", function () {
            cursor.removeClass("drag");
        });


        //discover
        $(".hover-discover").on("mouseenter", function () {
            cursor.addClass("cursor-discover");
        });
        
        $(".hover-discover").on("mouseleave", function () {
            cursor.removeClass("cursor-discover");
        });

        //photo gallery
        $(".hover-gallery").on("mouseenter", function () {
            cursor.addClass("cursor-gallery");
        });
        $(".hover-gallery").on("mouseleave", function () {
            cursor.removeClass("cursor-gallery");
        });

        //scroll
        $(".hover-scroll").on("mouseenter", function () {
            cursor.addClass("cursor-scroll");
        });
        $(".hover-scroll").on("mouseleave", function () {
            cursor.removeClass("cursor-scroll");
        });
  
    }
        */
}


/**
 * Carica il source video corretto (mobile/desktop) tramite data-src
 */
function initVideoSources(container) {
    
    console.log("initVideoSources");

    var root = container || document;
    var isMobile = window.innerWidth < 960;
    var idToRemove = isMobile ? 'desk' : 'mobile';
    root.querySelectorAll('source#' + idToRemove).forEach(function(source) {
        var video = source.closest('video');
        source.remove();
        if (video) {
            video.load();
        }
    });
}


/**
 * Header negativo/positivo in base all'attributo data-negativo delle section
 * Aggiunge/rimuove la classe "header-negativo" sul body
 */
function initHeader() {

    const sections = document.querySelectorAll('[data-negativo]:not([data-barba="container"])');
    if (!sections.length) return;

    function update() {
        const header = document.getElementById('page_header');
        const checkY = window.scrollY + (header ? header.offsetHeight : 100);

        for (const section of sections) {
            const top = section.offsetTop;
            const bottom = top + section.offsetHeight;
            if (checkY >= top && checkY < bottom) {
                document.body.classList.toggle('header-positivo', section.getAttribute('data-negativo') === 'false');
                break;
            }
        }
    }

    // stato iniziale
    update();

    // rimuove handler precedente se esiste (cambio pagina barba)
    if (window._negativoScrollHandler && window.lenis) {
        window.lenis.off('scroll', window._negativoScrollHandler);
    }
    window._negativoScrollHandler = update;
    window.lenis.on('scroll', update);
}


function initMenu(){
    const menuButton = document.getElementById('openMenu');
const menuBg = document.getElementById('bgMenu');

    if (!menuButton || !menuBg) return;

    const ANIMATION_DURATION = 500; // deve combaciare col CSS

    function openMenu() {
        if (document.body.classList.contains('menu-open')) return;

        // Compensa la larghezza della scrollbar per evitare lo scatto del layout
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) {
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }

        document.body.classList.remove('menu-closing');
        document.body.classList.add('menu-open');
        lenis.stop();
    }

    function closeMenu() {
        if (!document.body.classList.contains('menu-open')) return;

        document.body.classList.add('menu-closing');

        setTimeout(() => {
            document.body.classList.remove('menu-open', 'menu-closing');
            document.body.style.paddingRight = '';
            lenis.start();
        }, ANIMATION_DURATION);
    }

    //per poterle richiamare da fuori (es al cambio pagina)
    window.openMenu = openMenu;
    window.closeMenu = closeMenu;

    // TOGGLE
    menuButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (document.body.classList.contains('menu-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    menuBg.addEventListener('click', closeMenu);

    // chiudi menu al click sulle voci (barba gestisce la navigazione)
    document.querySelectorAll('#mainMenu a').forEach(function(link) {
        link.addEventListener('click', closeMenu);
    });

    //openMenu();
}


/**
 * Fade out del logo Swiss Engineering quando raggiunge la metà del viewport
 */
function initLogoSwiss() {
    const logo = document.querySelector('.c-logoSwiss');
    if (!logo) return;

    gsap.to(logo, {
        autoAlpha: 0,
        ease: 'none',
        scrollTrigger: {
            trigger: logo,
            start: 'center 50%',
            end: 'center 20%',
            scrub: true
        }
    });
}


/**
 * Effetto pannelli scrollabili (homepage)
 * Riproduce l'effetto mwg_031: ogni slide si piega e svanisce al passaggio dello scroll
 */
function initPannelli() {

    const section = document.querySelector('.pannelli');
    if (!section) return;

    gsap.to('.pannelli .scroll', {
        autoAlpha: 0,
        duration: 0.2,
        scrollTrigger: {
            trigger: '.pannelli',
            start: 'top top',
            end: 'top top-=1',
            toggleActions: 'play none reverse none'
        }
    });

    const slides = section.querySelectorAll('.slide');

    slides.forEach(function(slide) {
        const contentWrapper = slide.querySelector('.content-wrapper');
        const content = slide.querySelector('.content');

        gsap.to(content, {
            rotationZ: (Math.random() - 0.5) * 10,
            scale: 0.7,
            rotationX: 40,
            ease: 'power1.in',
            scrollTrigger: {
                pin: contentWrapper,
                trigger: slide,
                start: 'top 0%',
                end: '+=' + window.innerHeight,
                scrub: true
            }
        });

        gsap.to(content, {
            autoAlpha: 0,
            ease: 'power1.in',
            scrollTrigger: {
                trigger: content,
                start: 'top -80%',
                end: '+=' + 0.2 * window.innerHeight,
                scrub: true
            }
        });
    });
}


/**
 * Aggiorna la voce attiva del menu in base al namespace corrente
 */
function updateMenuActive() {
    document.querySelectorAll('#mainMenu a').forEach(function(link) {
        link.classList.remove('active');
        try {
            if (link.getAttribute('href') && new URL(link.href).pathname === window.location.pathname) {
                link.classList.add('active');
            }
        } catch(e) {}
    });
}


/**
 * Aggiorna il dom.
 * Sono possibili diverse strategie (combinarle a bisogno):
 * 1. sostituire in toto l'head (questo scatena anche anche esecuzione degli script, anche inline)
 * 2. sostituire tag specifici nell'head
 * 3. - inserire script/style specifici per la nuova pagina nel container di quest'ultima.
 *    - caricare gli script in ajax, mentre eventuali tag <style> presenti nel container verranno automaticamente valutati dal browser
 * 
 * Con gli stessi sistemi si possono aggiornare elementi al di fuori del container di barba
 */
function updateDom(data, callback) {

    var html = data.next.html;
    var newHeadHtml = html.match( /<head[\s\S]*?>[\s\S]*?<\/head>/gi )[0];

    // true mantiente gli script
    var $newPageHead = $.parseHTML(newHeadHtml, document, true);


    /**
     * Aggiorno namespace di body 
     */
    $("body").attr("data-namespace", data.next.namespace);


    /**
     * Aggiorno elemento attivo menu principale
     */
    $("#page_header-mainmenu .uk-active").removeClass("uk-active");
    $('#page_header-mainmenu [data-namespace="'+data.next.namespace+'"]').addClass("uk-active");
    
    
    /**
     * aggiorno html altri elementi
     * In ogni elemento dell'array inserire:
     * - o il selettore completo
     * - o il selettore + l'attributo che si vuole rimpiazzare
     */
    [
        'head',
        '#page_header-mainmenu',
        ['#page_header .logo a', 'href'],
        '#page_footer .info_menu',
        '#locale-label',
        '#header-lang ul',
        '#menu-lang',
        '#footer-lang'
    ].forEach((selector) => {

        let realSelector = Array.isArray(selector) ? selector[0] : selector;
        let attribute = Array.isArray(selector) ? selector[1] : null;

        // recupero elemento nel nuovo html in arrivo
        let el = $(realSelector, $(data.next.html));

        // no lambda qui!
        $(realSelector).each(function() {
            if(attribute !== null) {
                // rimpiazzo attributo
                $(this).attr(attribute, el.attr(attribute));
            } else {
                // rimpiazzo contenuto html nella pagina
                $(this).html(el.html());
            }
        });

    });


    /**
     * 1. aggiornamento in toto dell'head
     */
    //$("head").html(newHeadHtml);

    
    /**
     * 2. aggiornamento di script specifici nell'head
     */
    $newPageHead = $( '<head />' ).html($newPageHead);
    var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
        "link[rel='alternate']"
    ].join( ',' );
    
    $( 'head' ).find( headTags ).remove();
    
    $newPageHead.find( headTags ).appendTo( 'head' );
    /**
     * 2. // fine
     */


    /**
     * 3. Caricamento degli script presenti nel container della nuova pagina
     */
    $(data.next.container).find('script').each(function (i, script) {
        var $script = $(script);

        // script linkato
        if($script.attr('src')) {
            $.getScript($script.attr('src'));
        // script inline
        } else {
            $script.appendTo('[data-barba="container"]');
        }
        
    });
    /**
     * 3. // fine
     */

    if(callback && typeof(callback) == 'function') {
        return callback();
    }

    return true;

}


/**
 * Effetto hover con anteprima immagine flottante che segue il cursore (x e y).
 * Uso: aggiungere data-list-hover al wrapper, .c-lhover-medias con le img precaricate,
 * .c-lhover-container come contenitore flottante. 
 */
function initListHover() {
    if (window.matchMedia('(hover: none)').matches) return;

    document.querySelectorAll('[data-list-hover]').forEach(root => {
        const listElement = root.querySelector('ul');
        const rows = listElement.querySelectorAll('li');
        const container = root.querySelector('.c-lhover-container');

        const mediasEl = root.querySelector('.c-lhover-medias');
        const xposAttr = mediasEl ? mediasEl.getAttribute('data-xpos') : null;

        const breakpoints = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 };

        function parseXpos(attr) {
            if (!attr) return null;
            const parts = attr.trim().split(/\s+/);
            const map = { base: null };
            parts.forEach(part => {
                const colonIdx = part.indexOf(':');
                if (colonIdx === -1) {
                    map.base = parseFloat(part);
                } else {
                    const bp = part.slice(0, colonIdx);
                    map[bp] = parseFloat(part.slice(colonIdx + 1));
                }
            });
            return map;
        }

        function resolveXpos(map) {
            if (!map) return null;
            const w = window.innerWidth;
            const active = Object.entries(breakpoints)
                .filter(([bp, minW]) => map[bp] !== undefined && w >= minW)
                .sort((a, b) => b[1] - a[1]);
            if (active.length) return active[0][0] in map ? map[active[0][0]] : map.base;
            return map.base;
        }

        const xposMap = parseXpos(xposAttr);

        const mediasUrl = [];
        root.querySelectorAll('.c-lhover-medias img').forEach(img => {
            mediasUrl.push(img.getAttribute('src'));
        });

        listElement.addEventListener('mouseenter', (e) => {
            cursorX = e.clientX;
            cursorY = e.clientY;
            container.classList.add('on');
            updateContainerPos();
        });
        listElement.addEventListener('mouseleave', () => {
            container.classList.remove('on');
            Array.from(container.children).forEach(el => el.remove());
        });

        const xTo = gsap.quickTo(container, 'x', { duration: 0.6, ease: 'power4' });
        const yTo = gsap.quickTo(container, 'y', { duration: 0.5, ease: 'power4' });

        // Pre-posiziona il container subito così il primo hover non parte da 0,0
        (function prePosition() {
            const rect = root.getBoundingClientRect();
            const xpos = resolveXpos(xposMap);
            const initX = xpos !== null ? rect.width * (xpos / 100) : rect.width / 2;
            const initY = rect.height / 2;
            gsap.set(container, { xPercent: 0, yPercent: 0, x: initX, y: initY });
        })();

        let cursorX = 0, cursorY = 0;

        function updateContainerPos() {
            const rect = root.getBoundingClientRect();
            const xpos = resolveXpos(xposMap);
            const x = xpos !== null
                ? rect.width * (xpos / 100)
                : cursorX - rect.left;
            xTo(x);
            yTo(cursorY - rect.top);
        }

        listElement.addEventListener('mousemove', (e) => {
            cursorX = e.clientX;
            cursorY = e.clientY;
            updateContainerPos();
        });

        window.addEventListener('scroll', () => {
            if (container.classList.contains('on')) {
                updateContainerPos();
            }
        }, { passive: true });

        rows.forEach((row, index) => {
            row.addEventListener('mouseenter', () => {
                createMedia(index);
            });
        });

        const isFade = root.getAttribute('data-list-hover') === 'fade';

        function createMedia(index) {
            const div = document.createElement('div');
            const image = document.createElement('img');

            image.src = mediasUrl[index];
            div.appendChild(image);
            container.appendChild(div);

            if (isFade) {
                gsap.fromTo(div, { opacity: 0 }, { opacity: 1, duration: 0.1, ease: 'power2.out' });
            } else {
                gsap.to([div, image], {
                    y: 0,
                    duration: 0.6,
                    ease: 'expo.inOut'
                });
            }

            if (container.children.length > 20) {
                container.children[0].remove();
            }
        }
    });
}


/**
 * Slider storia (sezione about)
 */
function initStoriaSlider() {
    const el = document.querySelector('.storia-swiper');
    if (!el) return;

    if (el._storiaSwiper) {
        el._storiaSwiper.destroy(true, true);
    }

    el._storiaSwiper = new Swiper('.storia-swiper', {
        slidesPerView: 1.3,
        spaceBetween: 0,
        navigation: {
            nextEl: '.storia-swiper .swiper-button-next',
            prevEl: '.storia-swiper .swiper-button-prev',
        },
        breakpoints: {
            500: {
                slidesPerView: 2,
            },
            960: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
            1400: {
                slidesPerView: 5,
            },
        },
    });
}